<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--BEYONDCX DETAIL-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="contentData">
    <section class="beyond-cx">
      <div class="wrapper">
        <!--BEYONDCX CONTENT-->
        <div class="columns">
          <!--LEFT SIDE CONTENT-->
          <!--NOTE ngIf used to populate WordPress contentd-->
          <div [ngClass]="showScheduleConsultation ? 'left-aside-column' : ''">
            <app-static-page
              [title]="contentData?.title"
              [bodyContent]="contentData?.content | safe : 'html'">
            </app-static-page>
          </div>

          <!--LEFT SIDE CONTENT-->

          <!--NOTE: Hiding the "Schedule a Consultation" Form as required in BEYOND-2929-->
          <!--RIGHT SIDE CONTENT -->
          <!--SCHEDULE CONSULTATION-->
          <ng-container *ngIf="showScheduleConsultation">
            <div class="right-aside-column">
              <!--BEYONDCX TITLE-->
              <h3 class="text-align-center margin-bottom-small">Schedule a Consultation</h3>
              <!--END BEYONDCX TITLE-->
              <!--LOAD ELOQUA BEYONDCX FORM-->
              <div class="beyond-cx-form-demo">
                <!--BEYONDCX DESCRIPTION CONTENT-->
                <p class="margin-bottom-small">
                  To learn more about our comprehensive contact center learning solution, complete
                  the form below to request a consultation with one of our education advisors.
                </p>
                <!--END BEYONDCX DESCRIPTION CONTENT-->
                <!--NOTE: Form Type 'beyondcx' is defined by Genesys Marketing. Do not change, unless Marketing request this.-->
                <app-eloqua-form
                  [formType]="'beyondcx'"
                  [redirectUrl]="'https://beyond.genesys.com/explore/beyond-cx'">
                </app-eloqua-form>
              </div>
              <!--END LOAD ELOQUA BEYONDCX FORM-->
            </div>
          </ng-container>
          <!--END SCHEDULE CONSULTATION-->
          <!--END RIGHT SIDE CONTENT -->
        </div>
      </div>
      <!-- AI ESSENTIALS HERO START -->
      <app-hero-banner
        [id]="'ai-essentials-banner'"
        [heroImageCss]="'certifications-hero'"
        [displayCss]="['flexbox', 'flexwrap']"
        [alignContentCss]="['hero-wrapper-left', 'text-color-white']"
        [title]="'AI Essentials Certifications'"
        [description]="
          'AI Essentials offers role-based, embedded certifications within the course content, designed to validate practical AI capability across Genesys Cloud, with no separate exam voucher required.'
        "
        [showButton]="false"
        [routeType]="routeTypes.INTERNAL"
        [route]="'/subscription/ai-essentials'"
        [actionLabel]="'Learn More'"
        [customButtonCss]="['btn-brand', 'larger-btn', 'padding-right-small']">
      </app-hero-banner>
      <!-- AI ESSENTIALS HERO END -->

      <!--BEYONDCX TESTIMONIALS START-->
      <app-testimonials
        *ngIf="showTestimonials"
        [testimonials]="testimonials"
        [testimonialAlignmentCSS]="['testimonial-content', 'text-align-left', 'margin-right-large']"
        [testimonialWrapperCSS]="['testimonial-wrapper-center', 'testimonial-text-color']"
        [testimonialBackgroundCSS]="['testimonials-light-blue']"
        [arrowColorCSS]="'white'"
        [carouselDotActiveCSS]="'white-active'">
      </app-testimonials>
      <!--END BEYONDCX TESTIMONIALS-->
    </section>
  </ng-container>
</ng-template>
<!--END BEYONDCX DETAIL-->

<!--BEYONDCX MODAL SUCCESS MESSAGE-->
<app-modal-dialog [containerID]="'eloqSuccessModal'" [modalMaxWidth]="'modal-max-width-small'">
  <div #modalContainer>
    <h4 class="text-align-center margin-bottom-large">Thank you for your interest in BeyondCX!</h4>
    <p class="text-align-center">
      One of our educational advisors will contact you soon with further details.
    </p>
  </div>
</app-modal-dialog>
<!--END BEYONDCX MODAL SUCCESS MESSAGE-->
